import * as React from 'react';
import { arrayMoveImmutable } from 'array-move';

export type UnitContextItem = {
  id?: number | string;
  tempId?: number;
  title: string;
  description: string;
  unitType: 'Free' | 'Premium';
  order?: number;
  _destroy?: boolean;
  coverUrl?: string;
  posterUrl?: string;
  videoUrl?: string;
  audioUrl?: string;
};

interface CourseModuleContextProps {
  courseModule: any;
  index: number;
  units: UnitContextItem[];
  setUnit: (unit: UnitContextItem, unitIndex: number) => void;
  createNewUnit: () => void;
  deleteUnit: (unit: UnitContextItem, forced?: boolean) => void;
  onSortEnd: ({ oldIndex, newIndex, nodes }: { oldIndex: number; newIndex: number; nodes?: any[] }) => void;
  errors?: Record<string, any>;
}

interface CourseModuleProviderProps {
  children: JSX.Element | JSX.Element[];
  courseModule: any;
  index: number;
  setCourseModule: (value: any) => void;
}

export const CourseModuleContext = React.createContext({} as CourseModuleContextProps);

export function CourseProvider({children, courseModule, index, setCourseModule} : CourseModuleProviderProps){
  const [errors] = React.useState<Record<string, any>>({});
  const [units, setUnits] = React.useState<UnitContextItem[]>(courseModule?.units || [] as UnitContextItem[]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [progress,setProgress] = React.useState<number>(0);
  const [loadingMessage, setLoadingMessage] = React.useState(null);  

  const setUnit = (unit: UnitContextItem, unitIndex: number) => {
    const newUnits = [...units];
    newUnits[unitIndex] = unit;
    setUnits(newUnits);
  }

  React.useEffect(() => {
    if(courseModule.units !== units){
      const newCourseModule = {...courseModule, units};
      setCourseModule(newCourseModule);
    }
  }, [units])

  const createNewUnit = () => {
    const newUnit: UnitContextItem = {
      id: '',
      tempId: new Date().getTime(),
      title: '',
      description: '',
      unitType: 'Premium',
    };
  
    const newUnits = [...units, newUnit];
    setUnits(newUnits)
    setTimeout(() => {
      const el = document.getElementById(`coursemodule-${index}-unit-${units.length}`);
      if (el && 'focus' in el) (el as HTMLElement).focus();
    }, 10);
  };

  const deleteUnit = (unit: UnitContextItem, forced = false) => {
    let newUnit = {...unit};
    const unitIndex = units.indexOf(unit)
    if (unit.id && !forced) {
      newUnit = {...unit, '_destroy': true}
      const newUnits = [...units];
      newUnits[unitIndex] = newUnit;
      setUnits(newUnits);
    } else {
      const newUnits = [...units];
      newUnits.splice(unitIndex, 1);
      setUnits(newUnits);
    }
  };

  const onSortEnd = ({oldIndex, newIndex, nodes}: { oldIndex: number; newIndex: number; nodes?: any[] }) => {
    const newUnits = arrayMoveImmutable(units, oldIndex, newIndex);
    setUnits(newUnits);
  };

  return (
    <CourseModuleContext.Provider 
      value={{
        courseModule,
        index,
        units,
        setUnit,
        createNewUnit,
        deleteUnit,
        onSortEnd,
        errors
      }}>
        {children}
      </CourseModuleContext.Provider>)
}
